import React, { Component } from 'react';
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import withValidator from '../../models/form/withValidator';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    description: {
      rules: [
        {
          feedback: 'Description is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    title: {
      rules: [
        {
          feedback: 'Title is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
  },
};

class TPForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {
        description: '',
        title: '',
      },
      description: !this.props.initialValues ? '' : this.props.initialValues.description,
      errorFeedback: {},
      isFormDisabled: true,
      title: !this.props.initialValues ? '' : this.props.initialValues.title,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({ description: this.state.description });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      // eslint-disable-next-line max-len
      isFormDisabled: this.getIsFormInvalid(nextProps.hasErrors, nextProps.touched, nextProps.hasUntouched),
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  getIsFormInvalid(hasErrors, touched, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value);
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => this.props.validateField(name, value, true));
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      description: this.state.description,
      title: this.state.title,
    };
    this.props.onSave(properties);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        <FormGroup>
          <Label for="title">Title *</Label>
          <Input
            className={this.state.cssValidationClasses.title}
            id="title"
            name="title"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            placeholder="Description"
            type="text"
            value={this.state.title}
          />
          <FormFeedback>{this.state.errorFeedback.title}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="description">Description *</Label>
          <Input
            className={this.state.cssValidationClasses.description}
            id="description"
            name="description"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            placeholder="Description"
            type="textarea"
            value={this.state.description}
          />
          <FormFeedback>{this.state.errorFeedback.description}</FormFeedback>
        </FormGroup>
        <div className="text-right">
          <button className="button primary" disabled={this.state.isFormDisabled}>   Submit </button>
        </div>
      </Form>
    );
  }
}

export default withValidator(TPForm, validatorConfig);
